import jwtDefaultConfig from '@core/auth/jwt/jwtDefaultConfig'

export default function clearLocalSession(jwtConfig = jwtDefaultConfig) {
  [jwtConfig.storageTokenKeyName, jwtConfig.storageRefreshTokenKeyName, 'userData', 'role', 'cache']
    .forEach(key => localStorage.removeItem(key))
}
